import React, { useMemo } from "react";
import "./HeroSectionComponent.scss";
import homePhoto from "./home_photo.png";

const HeroSectionComponent = ({
  brideName = "Bride",
  groomName = "Groom",
  ceremonyType = "wedding",
  weddingDate = "12 December 2026",
  weddingVenue = "Colombo, Sri Lanka",
  loadedBanner,
  canShowSeatingArrangement = false,
  isRsvp = true,
  onScrollToRsvp = () => {},
  onScrollToSeat = () => {},
  onScrollToContent = () => {},
}) => {
  const isHomeComing = useMemo(() => {
    const normalized = String(ceremonyType).trim().toLowerCase();
    return (
      normalized === "home coming" ||
      normalized === "homecoming" ||
      normalized === "home-coming"
    );
  }, [ceremonyType]);

  const canShowRsvpButton = isRsvp !== false;

  const bannerSrc = useMemo(() => {
    const uploaded = typeof loadedBanner === "string" ? loadedBanner.trim() : "";

    if (uploaded && uploaded !== "undefined" && uploaded !== "null") {
      return uploaded;
    }

    return homePhoto;
  }, [loadedBanner]);

  return (
    <section className="heroSection is-banner-ready">
      <img
        src={bannerSrc}
        alt={`${brideName} and ${groomName}`}
        className="heroSection__photo"
        loading="eager"
        fetchPriority="high"
        decoding="sync"
        draggable="false"
        onError={(e) => {
          if (e.currentTarget.src !== homePhoto) {
            e.currentTarget.src = homePhoto;
          }
        }}
      />

      <div className="heroSection__overlay" />

      <div className="heroSection__content">
        <p className="heroSection__eyebrow">Together with their families</p>

        <h1 className="heroSection__heading">
          <div>
            {isHomeComing ? (
              <>
                <span className="heroSection__name">{groomName}</span>
                <span className="heroSection__amp">&amp;</span>
                <span className="heroSection__name">{brideName}</span>
              </>
            ) : (
              <>
                <span className="heroSection__name">{brideName}</span>
                <span className="heroSection__amp">&amp;</span>
                <span className="heroSection__name">{groomName}</span>
              </>
            )}
          </div>
        </h1>

        <p className="heroSection__subtitle">
          {isHomeComing
            ? "invite you to celebrate their homecoming"
            : "are getting married"}
        </p>

        <div className="heroSection__dateWrap">
          <div className="heroSection__dateBlock">
            <span className="heroSection__dateLabel">Join us on</span>
            <span className="heroSection__date">{weddingDate}</span>
            <span className="heroSection__separator" />
            <span className="heroSection__location">{weddingVenue}</span>
          </div>
        </div>

        {(canShowRsvpButton || canShowSeatingArrangement) && (
          <div className="heroSection__actions">
            {canShowRsvpButton && (
              <button
                type="button"
                className="heroSection__button"
                onClick={onScrollToRsvp}
              >
                RSVP
              </button>
            )}

            {canShowSeatingArrangement && (
              <button
                type="button"
                className="heroSection__button heroSection__button--ghost"
                onClick={onScrollToSeat}
              >
                Find My Seat
              </button>
            )}
          </div>
        )}
      </div>

      <button
        type="button"
        className="heroSection__scrollCue"
        onClick={onScrollToContent}
        aria-label="Scroll down"
      >
        <span className="heroSection__scrollText">Scroll</span>
        <span className="heroSection__scrollMouse">
          <span className="heroSection__scrollDot" />
        </span>
      </button>
    </section>
  );
};

export default HeroSectionComponent;